import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const POST_SKILLACQUISITIONDOMAIN_API = `${API_URL}/api/PatientSkillAcquisitionDomain/SavePatientSkillAcqDomain`;
export const GET_SKILLACQUISITIONDOMAIN_LIST_API = `${API_URL}/api/PatientSkillAcquisitionDomain/GetPatientSkillAcqDomains`;
export const GET_SKILLACQUISITIONDOMAIN_DETAIL_API = `${API_URL}/api/PatientSkillAcquisitionDomain/GetPatientSkillAcqDomainById`;
export const DELETE_SKILLACQUISITIONDOMAIN_API = `${API_URL}/api/PatientSkillAcquisitionDomain/DeletePatientSkillAcqDomain`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const POST_MASTER_DOMAIIN_DETAILS_LIST_API = `${API_URL}/api/MasterDomains/SaveMasterDomain`;
export const GET_SKILLACQUISITIONARCHIVEDDOMAIN_LIST_API = `${API_URL}/api/PatientSkillAcquisitionDomain/GetPatientSkillAcqArchivedDomains`;
export const GET_SKILLACQUISITIONARCHIVEDPROGRAM_LIST_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqArchivedPrograms`;
export const GET_SKILLACQUISITIONARCHIVEDTARGET_LIST_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqArchivedTargets`;
export const GET_DOMAIN_LIST_API = `${API_URL}/api/MasterDomains/GetMasterDomains`;
export const GET_PROGRAM_LIST_API = `${API_URL}/api/MasterPrograms/GetMasterPrograms`;
export const COPY_PATIENT_SKILLACQUISITION_DATA = `${API_URL}/api/PatientSkillAcquisitionProgram/CopyPatientSkillAcqDataToCurriculumLibrary`;
export const GET_SKILLACQUISITIONPROGRAM_LIST_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqPrograms`;
export const GET_SKILLACQUISITIONPROGRAM_LIST_MOVE_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqPrograms`;
export const MOVE_PATIENT_SKILLACQUISITION_DATA = `${API_URL}/api/PatientSkillAcquisitionProgram/MovePatientSkillAcqData`;


export const skillAcquisitionDomainActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    save_skillAcquisitionDomain: createRequestActionTypes('SAVE_SKILLACQUISITIONDOMAIN'),
    get_skillAcquisitionDomainList: createRequestActionTypes('GET_SKILLACQUISITIONDOMAINLIST'),
    get_skillAcquisitionDomainDetail: createRequestActionTypes('GET_SKILLACQUISITIONDOMAINDETAIL'),
    delete_skillAcquisitionDomain: createRequestActionTypes('DELETE_SKILLACQUISITIONDOMAIN'),
    post_masterDomainDetails: createRequestActionTypes('POST_MASTER_DOMAIN_DETAILS'),
    get_skillAcquisitionArchivedDomainList: createRequestActionTypes('GET_SKILLACQUISITIONARCHIVEDDOMAIN_LIST_API'),
    get_skillAcquisitionArchivedProgramList: createRequestActionTypes('GET_SKILLACQUISITIONARCHIVEDPROGRAM_LIST_API'),
    get_skillAcquisitionArchivedTargetList: createRequestActionTypes('GET_SKILLACQUISITIONARCHIVEDTARGET_LIST_API'),
    get_domainList: createRequestActionTypes('GET_DOMAINLIST'),
    get_programList: createRequestActionTypes('GET_PROGRAMLIST'),
    post_patientSkillAcquisitionData : createRequestActionTypes('COPY_PATIENT_SKILLACQUISITION_DATA'),
    get_skillAcquisitionProgramList: createRequestActionTypes('GET_SKILLACQUISITIONPROGRAMLIST'),
    get_skillAcquisitionProgramListForMove: createRequestActionTypes('GET_SKILLACQUISITIONPROGRAM_LIST_MOVE_API'),
    move_patientSkillAcquisitionData :createRequestActionTypes('MOVE_PATIENT_SKILLACQUISITION_DATA'),
    get_skillAcquisitionProgramListForMoveReset: createRequestActionTypes('GET_SKILLACQUISITIONPROGRAM_LIST__API_RESET'),
};

export const MODULE = 'DCMASTER_SKILLACQUISITIONDOMAIN';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/constants/ApiConstants.js